import React, { Component } from 'react'
import './privacySettings.css'
import { browserHistory } from 'react-router'

class PrivacyOption extends Component {
  render() {
    return (
      <div className={`privacy-option ${this.props.selected ? 'selected' : ''} ${this.props.upgradeRequired ? 'disabled' : ''}`} onClick={this.props.onClick}>
        {this.props.upgradeRequired ?
          <div className="upgrade">Upgrade</div>
        : ''}
        <div className="radio"></div>
        {this.props.icon}
        <div className="description">
          <div className="title">{this.props.title}</div>
          <div className="subtitle">{this.props.subtitle}</div>
          {this.props.editPassword && this.props.selected ? 
            <input
              type="text"
              className="form-control password-input"
              placeholder="Enter a password here"
              onChange={e => {
                this.props.onChange(e.target.value)
              }}
            />
          : ''}
          {this.props.editPasswordButton && this.props.selected ? 
            <button className="change-password" onClick={ e=> {
              this.props.onEditPasswordButtonClicked()
            }}>Change Password</button>
          : ''}
        </div>
      </div>
    )
  }
}

export default class PrivacySettings extends Component {
  constructor() {
    super()
    this.state = {
      privacy: null,
      password: null
    }
  }

  reset() {
    this.setState({privacy: null, password: null, editPassword: false, editPasswordButton: false})
  }

  render() {
    const privacy = this.state.privacy == null ? this.props.video.privacy : this.state.privacy
    return (
      <div className="privacy-settings">
        <PrivacyOption 
          selected={!privacy} 
          icon=""
          title="Link Only (Default)"
          subtitle="Anyone with a link can watch this video."
          onClick={privacy => {
            this.setState({privacy: 0})
            this.props.onChange({privacy: 0})
          }}
        />
        <PrivacyOption 
          selected={privacy == 2} 
          icon=""
          title="Password Protected"
          subtitle="Only people with a password can watch this video."
          onClick={privacy => {
            if (!this.props.me.plan) {
              browserHistory.push(`/upgrade?src_internal=privacy-password-option`)
              return
            }
            this.setState({privacy: 2})
            this.props.onChange({privacy: 2, password: ''})
          }}
          editPassword={this.state.editPassword || this.props.video.privacy != 2}
          editPasswordButton={!this.state.editPassword && this.props.video.privacy == 2}
          onEditPasswordButtonClicked={e => {
            this.setState({editPassword: true})
          }}
          onChange={password => {
            this.props.onChange({privacy: 2, password})
          }}
          upgradeRequired={this.props.me.plan ? false : true}
        />
        <PrivacyOption 
          selected={privacy == 1} 
          icon=""
          title="Only Me"
          subtitle="Only you will be allowed to watch this video."
          onClick={privacy => {
            this.setState({privacy: 1})
            this.props.onChange({privacy: 1})
          }}
        />
      </div>
    )
  }
}
